export function hasDeliveryInfo(restaurant) {
    return restaurant.deliveryInfo !== null;
}
